/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- COMMENTING ANALYTICS - COMMENTING BEELINE REPORT : STYLES --------------- ++++++++++ */
export default {
    commentingbeelinereport: {
        marginBottom: pxToEm(16)
    }
};
